import React from "react";
import { injectIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import silentAvatar from "../../assets/avatares/sin-sonido.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import Scenario2NextCta from "./Scenario2NextCta";
import "../StartGame.css";
import "./Scenario2.css";

function Scenario2Context4() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="start-game-page sc2-context-page">
			<div className="start-game-inner start-game-inner--prep5">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Escenario 2 · Diagnóstico
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title">
							Resultado de la <span className="sg5-title-accent">colonoscopia</span>
						</h1>
						<p className="sg5-lead">Hallazgos endoscópicos y muestras para anatomía patológica.</p>
					</header>

					<div className="sg5-mosaic">
						<div className="sg5-mosaic-media">
							<div className="sg5-video-shell">
								<div className="start-game-avatar-inner start-game-avatar-inner--silent sg5-video-inner">
									<video autoPlay muted loop playsInline preload="auto" aria-hidden>
										<source src={silentAvatar} type="video/mp4" />
									</video>
								</div>
							</div>
						</div>

						<div className="sg5-mosaic-aside">
							<div className="sg5-aside-card sg5-aside-card--accent">
								<h2 className="sg5-aside-title">Informe endoscópico</h2>
								<p>
									Se realiza colonoscopia completa. A 35 cm del margen anal se observa una lesión
									vegetante, ulcerada, parcialmente estenosante, de aspecto neoplásico. El
									endoscopista logra progresar hasta ciego y no identifica otras lesiones sincrónicas
									relevantes.
								</p>
								<p className="mb-0">
									Se toman múltiples biopsias de la lesión y se solicita estudio anatomopatológico.
								</p>
							</div>

							<div className="sg5-aside-card">
								<h2 className="sg5-aside-title">Datos destacados</h2>
								<ul className="sc2-context-list mb-0">
									<li>Lesión en sigma/colon izquierdo.</li>
									<li>Aspecto endoscópico sospechoso de malignidad.</li>
									<li>Colonoscopia completa hasta ciego.</li>
									<li>Biopsias múltiples tomadas.</li>
									<li>Paciente clínicamente estable.</li>
								</ul>
							</div>

							<div className="sg5-aside-card">
								<h2 className="sg5-aside-title">Nota para el residente</h2>
								<p>
									La apariencia endoscópica orienta la sospecha, pero el diagnóstico oncológico
									requiere confirmación histológica.
								</p>
								<p className="mb-0">
									Esto encaja con la práctica clínica habitual: la biopsia de una lesión sospechosa
									suele realizarse durante la colonoscopia, y las muestras se envían a anatomía
									patológica para confirmar si hay cáncer.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="sg5-actions">
					<Scenario2NextCta
						navigateTo={ROUTES.SCENARIO2_QUIZ3}
						activeScenario={activeScenario}
						label="Continuar a la pregunta"
					/>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario2Context4);
